module.exports = __webpack_public_path__ + "static/media/cbon.f0ebb04a.png";